import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { RESONANCE_SORT } from '../constants';

const useResonanceMessagesListSort = () => {
  const { t } = useTranslation('resonance');

  return useMemo(
    () => [
      {
        label: t('total'),
        value: RESONANCE_SORT.TOTAL_MESSAGE,
        getSortValue: (message) => message.accurateR1Total + message.accurateR2Total,
      },
      {
        label: t('totalType', { type: RESONANCE_SORT.R1 }),
        value: RESONANCE_SORT.TOTAL_R1,
        getSortValue: (message) => message.accurateR1Total,
      },
      {
        label: t('totalType', { type: RESONANCE_SORT.R2 }),
        value: RESONANCE_SORT.TOTAL_R2,
        getSortValue: (message) => message.accurateR2Total,
      },
    ],
    [t],
  );
};

export default useResonanceMessagesListSort;
